import { Route } from '@angular/router';
import { TermsOfUseComponent } from './terms-of-use.component';

const route: Route = {
  path: 'terms-of-use',
  component: TermsOfUseComponent
};

export default route;
